export const SELECTED_ACADEMY_IDS_STORAGE_KEY = "selectedAcademyBranchIds";

export type StoredAcademyId = number | string;

export const readStoredAcademyBranchIds = (
  storageKey = SELECTED_ACADEMY_IDS_STORAGE_KEY,
): StoredAcademyId[] => {
  try {
    const stored = localStorage.getItem(storageKey);
    const parsed = stored ? JSON.parse(stored) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const writeStoredAcademyBranchIds = (
  academyIds: StoredAcademyId[],
  storageKey = SELECTED_ACADEMY_IDS_STORAGE_KEY,
) => {
  try {
    localStorage.setItem(
      storageKey,
      JSON.stringify(academyIds),
    );
  } catch (error) {
    console.error(error);
  }
};

export const sanitizeStoredAcademyBranchIds = (
  availableBranches: { value: StoredAcademyId }[],
  storageKey = SELECTED_ACADEMY_IDS_STORAGE_KEY,
): StoredAcademyId[] => {
  const stored = readStoredAcademyBranchIds(storageKey);
  if (stored.length === 0) {
    return stored;
  }

  const availableIdSet = new Set(
    availableBranches.map((branch) => String(branch.value)),
  );
  const sanitized = stored.filter((id) => availableIdSet.has(String(id)));

  if (sanitized.length !== stored.length) {
    writeStoredAcademyBranchIds(sanitized, storageKey);
  }

  return sanitized;
};
